module.exports = __webpack_public_path__ + "static/media/rainy.d3affa99.jpg";